<div class="grid">
    <div
        style="line-height: 1.25rem !important; transform: scale(0.75)"
        class="md:col-offset-3 col sm:col-12 md:col-3"
    >
        <label>Rate</label>
        <p-select
            #ddRate
            [autoDisplayFirst]="false"
            [style]="{ width: '100%' }"
            [virtualScroll]="true"
            [itemSize]="dropdownItemHeight"
            [options]="rates | orderBy: 'label'"
            appendTo="body"
            defaultLabel="Rate Type"
            placeholder="Rate Type"
            [filter]="true"
            (onChange)="getRules(ddRate.value, ddCostCenter.value)"
            [(ngModel)]="selectedRate"
        ></p-select>
    </div>
    <div
        class="col sm:col-12 md:col-3"
        style="line-height: 1.25rem !important; transform: scale(0.75)"
    >
        <label>Cost Center</label>
        <p-select
            #ddCostCenter
            [autoDisplayFirst]="false"
            [style]="{ width: '100%' }"
            [virtualScroll]="true"
            [itemSize]="dropdownItemHeight"
            [options]="costCenters | orderBy: 'label'"
            appendTo="body"
            defaultLabel="Cost Centers"
            placeholder="Cost Centers"
            [filter]="true"
            (onChange)="getRules(ddRate.value, ddCostCenter.value)"
            [(ngModel)]="selectedCostCenter"
        ></p-select>
    </div>

    <div class="col col-12" id="divIndirectRate" style="display: none">
        <!-- main content -->
        <div class="sticky-table-container">
            <p-table stripedRows #dtIndirectRateStructure
                [value]="items"
                tableStyleClass="p-datatable-full"
                styleClass="p-datatable-center"
                dataKey="id"
                [style]="{ 'min-width': '70em' }"
                editMode="row"
                (onFilter)="onFilter($event)"
                (onSort)="onSort($event)"
                (sortFunction)="customSort($event)"
                [customSort]="true"
            >
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="2" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header" let-item>
                    <tr>
                        <!-- Pool/Base -->
                        <th style="width: 10em">
                            <div class="tabulator-col-content">
                                <div class="tabulator-col-title">Pool/Base</div>
                                <p-sortIcon
                                    pSortableColumn="Pool_Base"
                                    field="Pool_Base"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </div>
                        </th>
                        <!-- Rate Components -->
                        <th>
                            <div class="tabulator-col-content">
                                <div class="tabulator-col-title">
                                    Rate Components
                                </div>
                                <p-sortIcon
                                    pSortableColumn="Ratecomponent"
                                    field="Ratecomponent"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </div>
                        </th>
                        <!-- Incl -->
                        <!-- <th style="width: 6em">
                            <div class="tabulator-col-content">
                                <div class="tabulator-col-title">Incl ?</div>
                                <p-sortIcon
                                    pSortableColumn="PayrollDisplay"
                                    field="PayrollDisplay"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </div>
                        </th> -->
                    </tr>
                </ng-template>
                <ng-template
                    pTemplate="body"
                    let-item
                    let-edit="editing"
                    let-ri="rowIndex"
                    let-rowData
                >
                    <tr class="p-datatable-row" data-id="row-{{ item.id }}">
                        <!-- Pool/Base -->
                        <td
                            *ngIf="
                                rowGroupMetadata[item.Pool_Base].index === ri
                            "
                            [attr.rowspan]="
                                rowGroupMetadata[item.Pool_Base].size
                            "
                            class="p-datatable-cell disabled"
                        >
                            <strong>
                                {{ item.Pool_Base }}
                            </strong>
                        </td>
                        <!-- Rate Components -->
                        <td class="p-datatable-cell disabled">
                            {{ item.Ratecomponent }}
                        </td>
                        <!-- Incl -->
                        <!-- <td class="p-datatable-cell disabled"></td> -->
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
